<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>STOCK DE MATERIALES EN DEPÓSITO</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listadoP" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="200" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">

                <template v-slot:item.fecha="{ item }">
                    <v-text-field dense v-model="item.fecha"></v-text-field>
                </template>
                <template v-slot:item.ruta="{ item }">
                    <v-text-field class="center" dense v-model="item.ruta"></v-text-field>
                </template>
            </v-data-table>
            <v-card color="orange" dark tile>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-app>
    </div>
</template>


<script>
import axios from "../../axios-auth";

export default {
    data: (vm) => ({
        usuario: "",
        editedItem: {
            descr: "",
            fecha: "",
            ruta: "",
        },
        editedIndex: -1,
        listadoP: [],
        deshabilitar: false,
        loadtable: false,
        headers: [
            { text: "Material", value: "descr", width: "35%", sortable: false },
            { text: "Fecha última actualización", align: "center", value: "fecha", width: "10%", sortable: false },
            { text: "Nombre archivo", value: "ruta", width: "55%", sortable: false },
        ],

    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                //this.usuario = this.$store.state.nombre.toString().trim();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            // this.vaciarModels();
            this.loadtable = true;
            let self = this;
            axios
                .get("/Icssa/ListadoStock?", {
                })
                .then((response) => {
                    self.listadoP = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listadoP = [];
                    console.log(error);
                });
        },
        guardar() {
            this.$swal({
                title: "Guardar Fechas Stock",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    let self = this;
                    axios
                        .post("/Icssa/GuardarFechaStock", this.listadoP)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Fechas actualizadas con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
        vaciarModels() {
            this.listadoP = [];
            this.$router.push({ name: "MainDeposito" });
        },
    },
};
</script>